var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "yxt-row",
        {
          staticClass: "yxt-user-selector-container yxt-user-multi-container",
          attrs: { type: "flex" },
        },
        [
          _c(
            "div",
            { staticClass: "yxtbiz-user-search-wrap mb16" },
            [
              _vm.enableGroupCorp
                ? _c("yxtbiz-group-org-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.visibleOrgSelector,
                        expression: "visibleOrgSelector",
                      },
                    ],
                    staticClass: "mr12",
                    attrs: {
                      size: "small",
                      setCurrentOrg: true,
                      selectFirst: true,
                      clearable: false,
                      visibleOrgIds: _vm.visibleOrgIds,
                      disabledOrgIds: _vm.disabledOrgIds,
                      targetOrgId: _vm.targetOrgId,
                      disabled: _vm.disabled,
                      functionCode: _vm.functionCode,
                      dataPermissionCode: _vm.dataPermissionCode,
                    },
                    on: {
                      change: _vm.handleOrgChange,
                      orgInvalid: _vm.orgInvalidHandler,
                    },
                  })
                : _vm._e(),
              _vm.isShowDeptment
                ? _c(
                    "select-popover",
                    {
                      ref: "selectPopover",
                      staticClass: "mr12",
                      attrs: {
                        size: "small",
                        "is-dept": "",
                        selectOpition: _vm.selectOpition,
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          (_vm.enableGroupCorp && _vm.userData.targetOrgId) ||
                          !_vm.enableGroupCorp
                            ? _c("dept-tree", {
                                ref: "deptTree",
                                attrs: {
                                  targetOrgId: _vm.userData.targetOrgId,
                                  visibleOrgSelector: false,
                                  enableGroupCorp: _vm.enableGroupCorp,
                                  functionCode: _vm.functionCode,
                                  dataPermissionCode: _vm.dataPermissionCode,
                                  filterable: true,
                                },
                                on: { nodeClick: _vm.selectDept },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _c("yxtbiz-type-search", {
                staticClass: "mr12",
                attrs: {
                  size: "small",
                  maxlength: "20",
                  kwType: _vm.userData.kwType,
                  keywords: _vm.userValue,
                  options: [1, 2],
                  selectCache: true,
                  searchable: "",
                },
                on: {
                  "update:kwType": function ($event) {
                    return _vm.$set(_vm.userData, "kwType", $event)
                  },
                  "update:kw-type": function ($event) {
                    return _vm.$set(_vm.userData, "kwType", $event)
                  },
                  "update:keywords": function ($event) {
                    _vm.userValue = $event
                  },
                  search: _vm.searchUser,
                },
              }),
            ],
            1
          ),
          _c(
            "yxt-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              key: "persons" + _vm.timeStamp,
              ref: _vm.refTable,
              staticClass: "yxt-user-table",
              attrs: {
                height: _vm.tableHeight,
                data: _vm.persons,
                "row-key": (row) => row.id,
              },
              on: { "select-all": _vm.selectAllUser, select: _vm.selectUser },
            },
            [
              _c("template", { slot: "empty" }, [
                _c(
                  "div",
                  { staticStyle: { "line-height": "normal" } },
                  [_c("yxt-empty")],
                  1
                ),
              ]),
              _vm.multiple
                ? _c("yxt-table-column", {
                    attrs: {
                      "show-overflow-tooltip": false,
                      "class-name": "yxtbiz-table-selection",
                      type: "selection",
                      width: "42",
                      "reserve-selection": "",
                      "clear-padding": "right",
                    },
                  })
                : _c("yxt-table-column", {
                    attrs: { "show-overflow-tooltip": false, width: "40" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("yxt-radio", {
                              attrs: { label: scope.row.id },
                              on: {
                                change: function ($event) {
                                  return _vm.selectUser(scope.row.id, scope.row)
                                },
                              },
                              model: {
                                value: _vm.singleSelect,
                                callback: function ($$v) {
                                  _vm.singleSelect = $$v
                                },
                                expression: "singleSelect",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
              _vm.multiple
                ? _c(
                    "yxt-table-column",
                    {
                      attrs: {
                        width: "18",
                        align: "right",
                        "clear-padding": "left-right",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c(
                            "yxt-dropdown",
                            {
                              attrs: { placement: "bottom-start" },
                              on: { command: _vm.tableHeaderCommand },
                            },
                            [
                              _c("span"),
                              _c(
                                "yxt-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "yxt-dropdown-item",
                                    { attrs: { command: "selectCurrent" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t(
                                              "pc_biz_enroll_select_current_page"
                                            )
                                            .d("选择本页")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "yxt-dropdown-item",
                                    { attrs: { command: "selectAll" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t("pc_biz_enroll_select_all")
                                            .d("选择全部")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "yxt-dropdown-item",
                                    { attrs: { command: "clearSelect" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t("pc_biz_enroll_clear_all")
                                            .d("清空所选")
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _c("yxt-table-column", {
                attrs: {
                  label: _vm.$t("pc_biz_core_lbl_name"),
                  "show-overflow-tooltip": true,
                  "popover-html": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.isOpenData
                          ? _c("yxtbiz-user-name", {
                              attrs: { name: scope.row.fullname },
                            })
                          : _c("span", [_vm._v(_vm._s(scope.row.fullname))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("yxt-table-column", {
                attrs: {
                  label: _vm.$t("pc_biz_core_lbl_accnum"),
                  prop: "username",
                  "show-overflow-tooltip": true,
                  "popover-html": true,
                },
              }),
              _c("yxt-table-column", {
                attrs: {
                  formatter: _vm.formatUserNo,
                  label: _vm.$t("pc_biz_udp_lbl_userNo"),
                  "show-overflow-tooltip": true,
                  prop: "userNo",
                },
              }),
              _c("yxt-table-column", {
                attrs: {
                  label: _vm.$t("pc_biz_core_lbl_department"),
                  "show-overflow-tooltip": true,
                  "popover-html": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !scope.row.deptName
                          ? _c("span", [_vm._v("--")])
                          : _vm.isOpenData
                          ? _c("yxtbiz-dept-name", {
                              attrs: { name: scope.row.deptName },
                            })
                          : _c("span", [_vm._v(_vm._s(scope.row.deptName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("yxt-table-column", {
                attrs: {
                  label: _vm.$t("biz_udp_position"),
                  "show-overflow-tooltip": true,
                  formatter: _vm.formatPostion,
                },
              }),
            ],
            2
          ),
          _c(
            "yxt-row",
            {
              staticClass: "yxtbiz-user-selector-mask mt16",
              attrs: { align: "middle", type: "flex" },
            },
            [
              _c("yxt-row", {
                staticClass: "col-flex-1",
                attrs: { type: "flex", align: "middle" },
              }),
              _c("yxt-pagination", {
                attrs: {
                  "current-page": _vm.page,
                  "page-size": _vm.userData.limit,
                  "simple-total": "",
                  layout: "total, prev, pager, next",
                  total: _vm.count,
                  "pager-count": 5,
                },
                on: {
                  "size-change": _vm.sizeChange,
                  "current-change": _vm.pageChange,
                  "update:currentPage": function ($event) {
                    _vm.page = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.page = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }